<a
  [href]="documentLinksService.customerAgreement$ | async"
  class="link"
  target="_blank"
>
  <span translate="footer.label.terms-and-conditions"></span>
</a>
<a
  [href]="documentLinksService.tradingConditions"
  class="link"
  target="_blank"
>
  <span translate="footer.label.trading-conditions"></span>
</a>
<a
  [href]="documentLinksService.riskWarning$ | async"
  class="link"
  target="_blank"
>
  <span translate="footer.label.risk-warning"></span>
</a>
<a
  [href]="documentLinksService.amlPolicy$ | async"
  class="link"
  target="_blank"
>
  <span translate="footer.label.policy"></span>
</a>
